var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo d-flex align-items-center",class:{ dark: _vm.dark },attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":""}}),_c('div',{staticClass:"logo__text"},[_c('strong',{staticClass:"d-block"},[_vm._v("Дрогобич Smart City")]),_c('span',[_vm._v(" Кабінет жителя ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }